import React from 'react';
import { BookOpen, Wrench, Target, Puzzle } from 'lucide-react';
export function PromiseSection() {
  const features = [{
    icon: BookOpen,
    text: 'Entendé el desarrollo de tu hijo mes a mes'
  }, {
    icon: Wrench,
    text: 'Herramientas prácticas para cada situación'
  }, {
    icon: Target,
    text: 'Estrategias probadas por +1.000 mamás'
  }, {
    icon: Puzzle,
    text: '100 actividades listas para hacer hoy'
  }];
  return <section className="bg-brand-cream py-24 px-6" data-id="element-221">
      <div className="max-w-4xl mx-auto text-center" data-id="element-222">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-brand-black mb-4" data-id="element-223">
          Existe una forma más simple de criar
        </h2>

        <p className="text-xl text-brand-charcoal/80 mb-12" data-id="element-224">
          Un sistema paso a paso que te da:
        </p>

        <div className="grid sm:grid-cols-2 gap-4 max-w-3xl mx-auto mb-16" data-id="element-225">
          {features.map((feature, index) => <div key={index} className="bg-white rounded-xl p-4 flex items-center gap-4 shadow-sm border border-brand-sage/10 text-left" data-id="element-226">
              <div className="bg-brand-sage/10 p-3 rounded-lg text-brand-sage" data-id="element-227">
                <feature.icon className="w-5 h-5" data-id="element-228" />
              </div>
              <span className="font-medium text-brand-charcoal" data-id="element-229">
                {feature.text}
              </span>
            </div>)}
        </div>

        <div className="text-2xl md:text-3xl font-serif text-brand-black max-w-2xl mx-auto leading-relaxed" data-id="element-230">
          Para que cada día sepas exactamente qué hacer.
        </div>
      </div>
    </section>;
}